<template>
	<Popup
		v-model="selfDisplay"
		title="企业微信"
		:confirmBtnDisplay="false"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div style="display: block;width: 280px;height: 280px;margin: 0 auto;background: #f5f5f5;">
				<img src="https://fc1tn.baidu.com/it/u=3386380274,1494337598&fm=202&mola=new&crop=v1" alt="" style="display: block;width: 280px;height: 280px;">
			</div>
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>微信号</span>
				<div class="b_block" style="width: 200px;">
					<el-input :value="code" disabled></el-input>
				</div>
				<div class="b_block" style="width: 70px;margin-left: 20px;">
					<el-button class="clipboard" type="primary" :data-clipboard-text="code">复制</el-button>
				</div>
			</div>
		</div>
	</Popup>
</template>

<script>
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted () {
			this.clipboardInstance = null;
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				
				code: '111'
			}
		},
		methods: {
			
		},
		watch: {
			display (newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay (newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.clipboardInstance = new this.Clipboard('.clipboard');
					this.clipboardInstance.on('success', () => {
						this.$message.success('复制成功');
					});
				} else {
					this.loading = false;
					this.clipboardInstance && this.clipboardInstance.destroy();
				}
			}
		}
	}
</script>

<style>
</style>
